export interface ITime {
	hours: number;
	minutes: number;
}

export function createTime(date: Date): ITime {
	return { hours: date.getHours(), minutes: date.getMinutes() };
}

export function getTimeInMinutes({ hours, minutes }: ITime) {
	return hours * 60 + minutes;
}

export function getLocalTimeToUTC(date: Date): Date {
	const userTimezoneOffset = date.getTimezoneOffset() * 60000;
	return new Date(date.getTime() + userTimezoneOffset);
}
